import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

function init() {
    initPopOver();
    $(document).on("dblclick", "#tblApproveSiteRequest tbody tr", goToSite);

    $(document).on("click", ".btnSiteApprove", function(e) {
        setSiteApproval(e.target, true);
    });

    $(document).on("click", "#btnSiteReject", function(e) {
        setSiteApproval(e.target, false);
    });

    $(document).on("click", ".btnSiteStartReject", hideAndShowPopovers);

    $(document).on("click", ".btnSiteCancelReject", hidePopover);

    $("#chkSearchAllSitesPendingApproval").click(getSitesPendingApproval);
}
function goToSite() {
    forms.showSpinner();
    window.location.href = application.baseUrl + "/sitedetails/index/" + $(this).attr("siteId");
}

function hideAndShowPopovers(e) {
    $(".btnSiteStartReject")
        .not($(this))
        .popover("hide");
    $(".btnSiteStartReject").popover();
}

function hidePopover(e) {
    const siteId = $(e.target).attr("siteId");
    $("#btnStartRejectSite-" + siteId).popover("hide");
}

function initPopOver() {
    $(".btnSiteStartReject").popover({
        container: "#divApproveSiteRequests",
        html: true,
        sanitize: false,
        animation: true,
        placement: "right",
        template:
            "<div class='popover' role='tooltip'><div class='arrow'> </div><h3 class='popover-header'></h3><div class='popover-body'></div></div>"
    });
}

function getSitesPendingApproval() {
    const checkBox = $("#chkSearchAllSitesPendingApproval");
    checkBox.prop("disabled", true).addClass("disabled");
    dataaccess
        .get({
            url: "/sites/PendingApproval/" + $(this).is(":checked"),
            accept: "text/html; charset=utf-8",
            dataType: "text/html"
        })
        .done(function(result) {
            $("#divApproveSite").html(result);
            initPopOver();
            setApproveSiteTableVisibleAndSitesToApproveCount();
        })
        .always(function() {
            checkBox.prop("disabled", false).removeClass("disabled");
        });
}

function setSiteApproval(target, isApproved) {
    let siteId;
    if (isApproved) {
        siteId = $(target.closest("tr")).attr("siteId");
    } else {
        siteId = $(target).attr("siteId");
    }
    let rejectedDecisionExplanation;
    const requestPayload = {
        url: "/Sites/" + siteId + "/Approval/",
        data: { isApproved: isApproved }
    };
    if (!isApproved) {
        rejectedDecisionExplanation = $("#txtSiteRejectReason-" + siteId).val();
        if (!rejectedDecisionExplanation || rejectedDecisionExplanation.length > 31) {
            $("#divSiteValidationWarning-" + siteId).removeClass("hidden");
            return;
        }
        $("#divSiteValidationWarning-" + siteId).addClass("hidden");
        requestPayload.data.rejectedDecisionExplanation = rejectedDecisionExplanation;
    }

    dataaccess
        .put(requestPayload)
        .done(function() {
            $(".btnSiteStartReject").popover("hide");
            $("#tblApproveSiteRequest [siteId=" + siteId + "]").remove();
            setApproveSiteTableVisibleAndSitesToApproveCount();
            services.notificationService.success(
                isApproved ? "Successfully Approved Site." : "Successfully Rejected Site."
            );
        })
        .fail(function() {
            $(".btnSiteStartReject").popover("hide");
        });
}

function setApproveSiteTableVisibleAndSitesToApproveCount() {
    const requestsLeft = $("#hdnSitesToApproveCount").val();
    $("[approveSiteBadge]").text(!requestsLeft ? "0" : requestsLeft);
    if (requestsLeft || parseInt(requestsLeft) > 0) {
        $("#divNoSitesToApprove").addClass("hidden");
        $("#divApproveSiteRequests").removeClass("hidden");
        return;
    }
    $("#divNoSitesToApprove").removeClass("hidden");
    $("#divApproveSiteRequests").addClass("hidden");
}

export const dashboardApproveSite = {
    init: init
};
